import React, { Component } from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import * as actions from '../../actions';
import { ADD_ERROR } from '../../actions/types';
import '../../css/sendmail.css';
import Footer from '../footer';
import Header from '../header';
import RenderFieldNotification from './renderFieldNotification';
import Spinner from './spinner';
import validate from './validate';

const FIXED_FROM = 'Alert@bookExpressNetwork.com';

class SendNotification extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    const { BookingID } = this.props.match.params;
    // fetch booking data to build initial values
    this.props.fetchBookingForNotification(BookingID);

    // ensure From has the fixed value in form state for validation/blur
    this.props.change('from', FIXED_FROM);

  }

  componentDidUpdate(prevProps) {
    const { user, initialValues } = this.props;
    const prevInit = prevProps.initialValues;

    // Run access checks ONLY after initialValues are available/updated
    if (initialValues && initialValues !== prevInit && user) {
      if (user.accessLevel === 'CUSTOMER') {
        const userCustomerId = String(user?.CustomerID ?? '');
        const consigneeId = String(initialValues?.consigneeID ?? '');
        if (userCustomerId && consigneeId && userCustomerId !== consigneeId) {
          this.props.history.push('/p/search');
          this.props.dispatch(this.addError('ACCESS DENIED'));
        }
      }
      if (user.accessLevel === 'AGENT') {
        const userId = String(user?.id ?? '');
        const bookingAgent = String(initialValues?.Agent ?? '');
        if (userId && bookingAgent && userId !== bookingAgent) {
          this.props.history.push('/p/search');
          this.props.dispatch(this.addError('ACCESS DENIED'));
        }
      }
    }
  }

  addError(error) {
    return {
      type: ADD_ERROR,
      payload: error
    };
  }

  renderField(field) {
    const {
      label,
      disabled,
      readOnly,
      input,
      meta: { touched, error }
    } = field;
    return (
      <div className="form-group form-group-sm">
        <div className="row">
          <label className="col-sm-3 col-form-label">{label}</label>
          <div className="col-sm-9">
            <input className="form-control" {...input} disabled={disabled} readOnly={readOnly} />
            <div className="text-danger">{touched ? error : ''}</div>
          </div>
        </div>
      </div>
    );
  }

  renderTextArea(field) {
    const { label, input } = field;
    return (
      <div className="form-group form-group-sm">
        <div className="row">
          <label className="col-sm-3 col-form-label">{label}</label>
          <div className="col-sm-9">
            <textarea className="form-control" rows="10" {...input} />
          </div>
        </div>
      </div>
    );
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return (
        <div className="container">
          <h2 className="text-center">Send Booking Notification</h2>
          <div className="col-sm-10 col-sm-offset-1">
            <div className="alert alert-danger">
              <strong>Oops!</strong> {this.props.errorMessage}
            </div>
            <Link to={`/p/booking/${this.props.match.params.BookingID}`}>Go back</Link>
          </div>
        </div>
      );
    }
    return null;
  }

  onSubmit({ to, cc, from, subject, message }) {
    
    const toSafe = Array.isArray(to) ? to.join(',') : (to || '');
    const ccSafe = Array.isArray(cc) ? cc.join(',') : (cc || '');
    const fromSafe = from || FIXED_FROM;

    const { BookingID } = this.props.match.params;

    const normalizedMessage = (message || '')
      .split('\n')
      .map(item => `<p>${item}</p>`)
      .join('');

    this.props.sendMail({ to: toSafe, cc: ccSafe, from: fromSafe, subject, message: normalizedMessage }, () => {
      this.props.history.push(`/p/booking/${BookingID}`);
      alert('Email sent!');
      // this.forceUpdate()
    });
  }

  render() {
    const { initialValues, handleSubmit, errorMessage } = this.props;

    
    if (!initialValues && !errorMessage) {
      return <Spinner />;
    }
    if (errorMessage) {
      return (
        <div>
          <Header />
          {this.renderAlert()}
          <Footer />
        </div>
      );
    }

    return (
      <div>
        <div className="col-sm-10 col-sm-offset-1">
          <h2 className="text-center">Send Booking Notification</h2>
          {this.renderAlert()}

          <form onSubmit={handleSubmit(this.onSubmit)}>
            {/* FROM: fixed + read-only so users can't change it */}
            <Field label="From:" name="from" component={this.renderField} readOnly />

            {/* TO */}
            <Field
              CNeeID={initialValues?.consigneeID}
              CNeeName={initialValues?.CNeeName}
              label="To:"
              name="to"
              component={RenderFieldNotification}
            />

            {/* CC */}
            <Field
              CNeeID={initialValues?.consigneeID}
              CNeeName={initialValues?.CNeeName}
              label="Cc:"
              name="cc"
              component={RenderFieldNotification}
            />

            <Field label="Subject:" name="subject" component={this.renderField} />
            <Field label="Message:" name="message" component={this.renderTextArea} />

            <div className="pull-right">
              <ButtonToolbar>
                <Button bsStyle="default" type="submit">
                  Send Mail
                </Button>
                <Button bsStyle="danger" href={`/p/booking/${this.props.match.params.BookingID}`}>
                  Go back
                </Button>
              </ButtonToolbar>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ bookings, auth }) {
  return {
    
    initialValues: bookings.notification ? { ...bookings.notification, from: FIXED_FROM } : null,
    user: auth.user,
    errorMessage: bookings.errorMessage
  };
}

SendNotification = reduxForm({
  form: 'SendNotification',
  enableReinitialize: true,
  validate
})(SendNotification);

SendNotification = connect(
  mapStateToProps,
  actions
)(SendNotification);

export default SendNotification;